export const SET_CONNECTION_ID = 'SET_RECENT_CONNECTION_ID';
export const SET_CONNECTION_LIST_PAGE = 'SET_CONNECTION_LIST_PAGE';
export const CONNECTION_LIST_SEARCH_TERM = 'CONNECTION_LIST_SEARCH_TERM';

export interface ISetConnectionIdAction {
    type: typeof SET_CONNECTION_ID;
    connectionId: string;
}

export interface ISetConnectionListPageAction {
    type: typeof SET_CONNECTION_LIST_PAGE;
    payload: number;
}

export interface ISearchConnectionListAction {
    type: typeof CONNECTION_LIST_SEARCH_TERM;
    searchTerm: string;
}

export type connectionReducerType = ISetConnectionListPageAction | ISearchConnectionListAction | ISetConnectionIdAction;
